import {DetailsField, DetailsFieldsSection} from '@/components/ui/details-atoms/DetailsAtoms'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {ProjectExtended} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'
import dayjs from 'dayjs'
import {useOutletContext} from 'react-router-dom'

export const ProjectDetailsSiarSection = () => {
    const {t} = useTranslation()
    const {project} = useOutletContext<{project: ProjectExtended}>()

    return (
        <Grid columns={2} gap={4} fullWidth>
            <DetailsFieldsSection variant="primary" title={t('projects:siar_opening')} width="100%">
                <Grid columns={2} fullWidth>
                    <DetailsField fullWidth>
                        <Text palette="neutral" shade="500" size="textSm">
                            {t('projects:siar_details_export_opening')}
                        </Text>
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            {project.openingExportedAt ? dayjs(project.openingExportedAt).format('DD/MM/YYYY') : '-'}
                        </Text>
                    </DetailsField>
                    <DetailsField fullWidth>
                        <Text palette="neutral" shade="500" size="textSm">
                            {t('projects:siar_details_transmission_opening')}
                        </Text>
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            {project.openingTransmissionAt
                                ? dayjs(project.openingTransmissionAt).format('DD/MM/YYYY')
                                : '-'}
                        </Text>
                    </DetailsField>
                </Grid>
            </DetailsFieldsSection>
            <DetailsFieldsSection variant="primary" title={t('projects:siar_closing')} width="100%">
                <Grid columns={2} fullWidth>
                    <DetailsField fullWidth>
                        <Text palette="neutral" shade="500" size="textSm">
                            {t('projects:siar_details_export_closing')}
                        </Text>
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            {project.closingExportedAt ? dayjs(project.closingExportedAt).format('DD/MM/YYYY') : '-'}
                        </Text>
                    </DetailsField>
                    <DetailsField fullWidth>
                        <Text palette="neutral" shade="500" size="textSm">
                            {t('projects:siar_details_transmission_closing')}
                        </Text>
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            {project.closingTransmissionAt
                                ? dayjs(project.closingTransmissionAt).format('DD/MM/YYYY')
                                : '-'}
                        </Text>
                    </DetailsField>
                </Grid>
            </DetailsFieldsSection>
        </Grid>
    )
}
